module.exports = __webpack_public_path__ + "static/media/shapes_25.3df6a016.svg";